import React, { PropsWithChildren, useState } from 'react';

import { Banner, BannerProps } from '@betterment/samba-react';

type BannerVariant = 'info' | 'success' | 'warning' | 'critical' | undefined;

export const BannerWrapper: React.FC<PropsWithChildren<BannerProps>> = ({ children, ...props }) => {
  const [isBannerVisible, setIsBannerVisible] = useState(true);
  const handleDismiss = () => setIsBannerVisible(false);
  const defaultProps = {
    variant: 'warning' as BannerVariant,
    css: { mt: 'space.200', mb: 'space.300' },
  };
  return (
    isBannerVisible && (
      <Banner {...defaultProps} {...props}>
        <Banner.Content>{children}</Banner.Content>
        <Banner.Close onClick={handleDismiss} />
      </Banner>
    )
  );
};
